import { FC, useEffect, useState } from "react";
import {
  ProdutoButtonQuantityNew,
  TrashIcon,
} from "../ProductButton";
import {
  calculatePriceFractionalToProduct,
  floatToPriceWithoutSpace,
} from "../../functions/price_functions";
import Swal from "sweetalert2";
import NoImg from "../../assets/images/no-image.png";
import "./productItem.css";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import useCart from "../../contexts/cartContext/cartContext";
import { Product } from "../../contexts/cartContext/cartType";
import { ProductType } from "../../contexts/OrderContext";

type CartItemProps = {
  product: Product;
  showOutStock?: boolean;
  motorTotvs?: boolean;
  canChange: boolean;
  hasCoupon: boolean;
  hasCashback?: boolean;
  typePluginspace?: string;
  omitGrid?: boolean;
};

const ProductItem: FC<CartItemProps> = ({
  product,
  showOutStock = false,
  motorTotvs = false,
  hasCoupon,
  hasCashback = false,
  typePluginspace = "",
  canChange,
  omitGrid = false,
}: CartItemProps) => {
  const [newQuantity, setNewQuantity] = useState(product.quantity);
  const { removeProduct, updateQuantity } = useCart();

  const { trackRemoveFromCart, trackQuantityChange } = useFaceBookPixel()

  const [priceAdditionals, setPriceAdditionals] = useState(0);

  const [loadingImage, setLoadingImage] = useState(true);

  useEffect(() => {
    if (product.additionals) {
      let _priceAdditionals = 0;
      product.additionals.map(
        (additional) =>
          (_priceAdditionals += additional.quantity * additional.price)
      );
      setPriceAdditionals(_priceAdditionals);
    }
  }, [product.additionals]);

  function changeQuantity(value: number) {
    const oldQuantity = product.quantity;
    if (value < 1) {
      removeProductCart(product);
    } else if (value <= product.stock || showOutStock) {
      updateQuantity(product, value);
      setNewQuantity(value);
      product.quantity = value;
      // Rastrear mudança de quantidade com dados tipados
      const productPrice = product.promotionalPrice > 0 ? product.promotionalPrice : product.unitPrice;
      const productData = {
        id: product.id,
        name: product.name,
        sku: product.sku || '',
        price: productPrice,
        quantity: value,
        category: ''
      };

      if (value > oldQuantity) {
        trackQuantityChange(productPrice, 'increase', productData);
      } else if (value < oldQuantity) {
        trackQuantityChange(productPrice, 'decrease', productData);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "Estoque máximo atingido",
        text: "Não será mais possível aumentar a quantidade do produto",
      });
    }
  }

  function removeProductCart(product: Product) {
    if (hasCoupon || hasCashback) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: hasCashback
          ? "Não é possível alterar produtos com cashback aplicado. Remova o cashback antes."
          : "Não é possível alterar a quantidade de produtos com cupom aplicado",
      });
      return;
    }

    Swal.fire({
      title: "Remover produto",
      text: "Deseja remover este produto do carrinho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim!",
    }).then((result: any) => {
      if (result.isConfirmed) {
        const productPrice = product.promotionalPrice > 0 ? product.promotionalPrice : product.unitPrice;
        const totalValue = productPrice * product.quantity;
        const productData = {
          id: product.id,
          name: product.name,
          sku: product.sku || '',
          price: productPrice,
          quantity: product.quantity,
          category: ''
        };

        // Rastrear remoção com dados tipados
        trackRemoveFromCart(totalValue, productData);

        setNewQuantity(0);
        product.quantity = 0;
        removeProduct(product);
      }
    });
  }

  function changeQuantidade(quantidade: number) {
    try {
      if (hasCoupon || hasCashback) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: hasCashback
            ? "Não é possível alterar produtos com cashback aplicado. Remova o cashback antes."
            : "Não é possível alterar a quantidade de produtos com cupom aplicado",
        });

        return;
      }

      changeQuantity(quantidade);
    } catch (error) { }
  }

  return (
    <div className={`productItem ${canChange ? "use_box_hadow" : ""}`}>
      <div className="product">
        <div className="image">
          <img src={product.image ? product.image : NoImg} alt="" />
        </div>
        <div className="productInfo">
          <div className="productHeader ">
            <div className="name">
              <p>{product.name}</p>
              {/* {product?.sku && (
                <p
                  style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontSize: "10px",
                    fontWeight: 600,
                    color: "#ababab",
                  }}
                >
                  Sku: <b>{product.sku}</b>
                </p>
              )} */}
            </div>
            {canChange && (
              <div className="trash">
                <TrashIcon action={() => removeProductCart(product)} />
              </div>
            )}
          </div>
          <div className="productInfoBotton">
            <div className="price">
              {product.promotionalPrice === 0 ||
                product.promotionalPrice === product.unitPrice ? (
                <p>
                  {product.type === "fractional"
                    ? floatToPriceWithoutSpace(
                      calculatePriceFractionalToProduct(product as ProductType) *
                      product.quantity +
                      priceAdditionals * product.quantity
                    )
                    : floatToPriceWithoutSpace(
                      product.unitPrice * product.quantity +
                      priceAdditionals * product.quantity
                    )}
                </p>
              ) : (
                <>
                  <p className="discouted_price">
                    {floatToPriceWithoutSpace(
                      product.unitPrice * product.quantity
                    )}
                  </p>

                  <p>
                    {floatToPriceWithoutSpace(
                      product.promotionalPrice * product.quantity
                    )}
                  </p>
                </>
              )}
            </div>
            <div className="options">
              {canChange ? (
                <ProdutoButtonQuantityNew
                  changeValuePositive={() => changeQuantidade(newQuantity + 1)}
                  changeValueNegative={() => changeQuantidade(newQuantity - 1)}
                  value={product.quantity}
                />
              ) : (
                <span>x{product.quantity} </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {!omitGrid && (
        <div className="productInfoSpecification">
          {Object.entries(product.variation).map((variation) => {
            if (variation[0] !== "VARIATION" && variation[1] !== "NONE") {
              return (
                <li className="values">
                  <span className="values">
                    {" "}
                    {variation[0]}: {variation[1]}
                  </span>
                </li>
              );
            } else {
              <></>;
            }
          })}
          {/* {product?.sku && (
            <li className="values">
              <span className="values">
                {" "}
                SKU: <b>{product.sku}</b>
              </span>
            </li>
          )} */}
        </div>
      )}
      {product.observation && (
        <div className="productInfoSpecification">
          <span className="title">Comentários do cliente</span>
          <div className="comments">
            <p>{product.observation}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export { ProductItem };
